import React from 'react';

import { useGetBuyerSpendingLimitRequest } from '../../../../api/lending/lapiHooks';
import { useSellerWhitelabelling } from '../../../../hooks/useSellerWhiteLabelling.hook';
import { useThreatMetrixProfiling } from '../../../../utils/threatMetrix/ThreatMetrixProfiling';
import { CancelButton } from '../../../components/CancelButton/CancelButton';
import { HelpBox } from '../../../components/HelpBox/HelpBox';
import { WhiteLabelHeaderLogo } from '../../../components/WhiteLabelLogo/WhiteLabelLogo';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { useCurrentPayLink } from '../../hooks/useCurrentPayLink';
import { RequirementsRouteConfig } from '../../routes';
import { CheckoutProgressIndicator } from '../CheckoutProgressIndicator';

export const CheckoutLayout = ({
  children,
  routes,
}: {
  children: React.ReactNode;
  routes: RequirementsRouteConfig[];
}) => {
  const { spendingLimitRequest } = useGetBuyerSpendingLimitRequest();
  const { payLink } = useCurrentPayLink();
  const cancelUrl = payLink?.cancel_url;
  // don't show cancel button on the captured payout complete page
  const shouldShowCancelButton =
    !window.location.pathname.includes('offer/complete');

  // White-label theme.
  const { theme, showSellerLogo } = useSellerWhitelabelling(
    payLink?.seller_handle || spendingLimitRequest?.data?.seller_handle,
  );

  useThreatMetrixProfiling(payLink?.seller_handle, payLink?.id);

  return (
    <>
      <div className="box-border min-h-screen overflow-hidden bg-secondary-97 text-left text-s font-reg [&_*]:box-border [&_h1]:text-l [&_h1]:font-bold [&_h1]:text-primary-10">
        {theme && showSellerLogo && (
          <div className="mx-auto max-w-[600px]">
            <WhiteLabelHeaderLogo
              // showSellerLogo = true --> logo_uri & preferred_logo_type present.
              url={theme.logo_uri!}
              ratio={theme.preferred_logo_type!}
            />
          </div>
        )}
        <WhiteLabelOverride componentType="progress">
          <CheckoutProgressIndicator routes={routes} />
        </WhiteLabelOverride>
        <div className="mx-auto w-full max-w-[600px]">
          {shouldShowCancelButton && (
            <CancelButton className="mb-xs" href={cancelUrl ?? undefined} />
          )}
          {children}
          <HelpBox />
        </div>
      </div>
    </>
  );
};
